/* CLEANEASE — Notifications d'achats en direct v2 */
(function () {
  'use strict';

  const ORDERS = [
    // Francophones
    { name: 'Alexandre', city: 'Montréal', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Sophie', city: 'Québec', lang: 'fr', product: 'le pack complet Magic Brush' },
    { name: 'Marc', city: 'Laval', lang: 'fr', product: 'les recharges Magic Brush' },
    { name: 'Julie', city: 'Longueuil', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Camille', city: 'Gatineau', lang: 'fr', product: 'le pack Magic Brush + recharges' },
    { name: 'Thomas', city: 'Sherbrooke', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Émilie', city: 'Brossard', lang: 'fr', product: 'les recharges Magic Brush' },
    { name: 'Nicolas', city: 'Lévis', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Isabelle', city: 'Trois-Rivières', lang: 'fr', product: 'le pack complet Magic Brush' },
    { name: 'François', city: 'Saint-Jean-sur-Richelieu', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Nathalie', city: 'Repentigny', lang: 'fr', product: 'les recharges Magic Brush' },
    { name: 'Maxime', city: 'Drummondville', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Amélie', city: 'Saguenay', lang: 'fr', product: 'le pack Magic Brush' },
    { name: 'Xavier', city: 'Terrebonne', lang: 'fr', product: 'la brosse électrique Magic Brush' },
    { name: 'Mélanie', city: 'Granby', lang: 'fr', product: 'les recharges Magic Brush' },
    // Anglophones
    { name: 'Sarah', city: 'Toronto', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'Michael', city: 'Vancouver', lang: 'en', product: 'the Magic Brush Bundle' },
    { name: 'Jessica', city: 'Calgary', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'David', city: 'Ottawa', lang: 'en', product: 'the Magic Brush Refills' },
    { name: 'Emily', city: 'Edmonton', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'Ryan', city: 'Mississauga', lang: 'en', product: 'the Magic Brush Bundle' },
    { name: 'Ashley', city: 'Brampton', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'Kevin', city: 'Winnipeg', lang: 'en', product: 'the Magic Brush Refills' },
    { name: 'Lauren', city: 'Hamilton', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'Chris', city: 'Kitchener', lang: 'en', product: 'the Magic Brush Bundle' },
    { name: 'Megan', city: 'Halifax', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'Brandon', city: 'London', lang: 'en', product: 'the Magic Brush Refills' },
    { name: 'Stephanie', city: 'Burlington', lang: 'en', product: 'the Electric Cleaning Brush' },
    { name: 'Tyler', city: 'Victoria', lang: 'en', product: 'the Magic Brush Bundle' },
    { name: 'Amanda', city: 'Oakville', lang: 'en', product: 'the Electric Cleaning Brush' }
  ];

  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function timeAgo(lang) {
    const mins = randomBetween(1, 55);
    if (lang === 'fr') {
      if (mins < 2) return 'à l\'instant';
      if (mins < 60) return 'il y a ' + mins + ' min';
      return 'il y a ' + Math.floor(mins / 60) + 'h';
    } else {
      if (mins < 2) return 'just now';
      if (mins < 60) return mins + ' min ago';
      return Math.floor(mins / 60) + 'h ago';
    }
  }

  function buildText(order) {
    if (order.lang === 'fr') {
      return `<strong>${order.name}</strong> de ${order.city} vient de commander ${order.product}`;
    } else {
      return `<strong>${order.name}</strong> from ${order.city} just purchased ${order.product}`;
    }
  }

  function injectStyles() {
    if (document.getElementById('ce-notif-styles')) return;
    const style = document.createElement('style');
    style.id = 'ce-notif-styles';
    style.textContent = `
      .ce-notif {
        position: fixed;
        bottom: 1.5rem;
        left: 1.5rem;
        z-index: 9999;
        display: flex;
        align-items: center;
        gap: 1rem;
        background: rgba(255,255,255,0.97);
        border: 1px solid rgba(186,230,253,0.75);
        border-left: 4px solid #0284C7;
        border-radius: 16px;
        padding: 1rem 1.25rem;
        max-width: 360px;
        min-width: 280px;
        box-shadow: 0 12px 48px rgba(2,132,199,0.22), 0 3px 12px rgba(0,0,0,0.09);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        font-family: 'Inter', -apple-system, sans-serif;
        transform: translateX(calc(-100% - 2rem));
        opacity: 0;
        transition: transform 0.45s cubic-bezier(0.22,1,0.36,1), opacity 0.45s ease;
        pointer-events: none;
      }
      .ce-notif.ce-notif--visible {
        transform: translateX(0);
        opacity: 1;
        pointer-events: auto;
      }
      .ce-notif.ce-notif--hiding {
        transform: translateX(calc(-100% - 2rem));
        opacity: 0;
      }
      .ce-notif__icon {
        width: 46px;
        height: 46px;
        min-width: 46px;
        background: linear-gradient(135deg, #0284C7, #0369A1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.35rem;
        box-shadow: 0 4px 16px rgba(2,132,199,0.35);
      }
      .ce-notif__content { flex: 1; min-width: 0; }
      .ce-notif__title {
        font-size: 0.88rem;
        font-weight: 500;
        color: #111827;
        margin: 0 0 0.2rem;
        line-height: 1.4;
      }
      .ce-notif__title strong { font-weight: 800; color: #0C4A6E; }
      .ce-notif__sub {
        font-size: 0.72rem;
        color: #6B7280;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 0.35rem;
      }
      .ce-notif__sub::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #10B981;
        border-radius: 50%;
        flex-shrink: 0;
        animation: ce-pulse 1.5s infinite;
      }
      @keyframes ce-pulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.5; transform: scale(0.8); }
      }
      .ce-notif__close {
        background: none;
        border: none;
        cursor: pointer;
        color: #D1D5DB;
        font-size: 1.1rem;
        padding: 0;
        line-height: 1;
        flex-shrink: 0;
        transition: color 0.15s;
        align-self: flex-start;
      }
      .ce-notif__close:hover { color: #6B7280; }
      /* Barre de progression */
      .ce-notif__progress {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        background: linear-gradient(90deg, #0284C7, #38BDF8);
        border-radius: 0 0 0 16px;
        animation: ce-progress linear forwards;
      }
      @keyframes ce-progress {
        from { width: 100%; }
        to { width: 0%; }
      }
      @media (max-width: 768px) {
        .ce-notif {
          bottom: 0.85rem;
          left: 0.85rem;
          right: 0.85rem;
          max-width: none;
          min-width: 0;
          padding: 0.85rem 1rem;
        }
        .ce-notif__icon { width: 40px; height: 40px; min-width: 40px; font-size: 1.15rem; }
        .ce-notif__title { font-size: 0.82rem; }
      }
    `;
    document.head.appendChild(style);
  }

  function createNotif(order) {
    const displayMs = randomBetween(6000, 8000);
    const el = document.createElement('div');
    el.className = 'ce-notif';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    const subText = order.lang === 'fr'
      ? `Achat vérifié · ${timeAgo('fr')}`
      : `Verified purchase · ${timeAgo('en')}`;

    el.innerHTML = `
      <div class="ce-notif__icon">🛒</div>
      <div class="ce-notif__content">
        <p class="ce-notif__title">${buildText(order)}</p>
        <p class="ce-notif__sub">${subText}</p>
      </div>
      <button class="ce-notif__close" aria-label="Fermer">✕</button>
      <div class="ce-notif__progress" style="animation-duration: ${displayMs}ms;"></div>
    `;

    document.body.appendChild(el);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => el.classList.add('ce-notif--visible'));
    });

    el.querySelector('.ce-notif__close').addEventListener('click', () => hide(el));
    setTimeout(() => hide(el), displayMs);
  }

  function hide(el) {
    el.classList.remove('ce-notif--visible');
    el.classList.add('ce-notif--hiding');
    setTimeout(() => el.parentNode && el.parentNode.removeChild(el), 500);
  }

  let usedIndexes = new Set();

  function showNext() {
    if (usedIndexes.size >= ORDERS.length) usedIndexes.clear();
    let idx;
    do { idx = randomBetween(0, ORDERS.length - 1); }
    while (usedIndexes.has(idx));
    usedIndexes.add(idx);
    createNotif(ORDERS[idx]);
    setTimeout(showNext, randomBetween(22000, 45000));
  }

  injectStyles();
  setTimeout(showNext, 7000);
})();
